import {Component, input} from '@angular/core';
import {RouterLink} from '@angular/router';
import {Crumbs} from '../../../classes/crumb.class';

/** "Seire › Platform : Backups › Checkpoint : nieuw"; crumbs with a route are links. */
@Component({
    selector: 'app-breadcrumbs',
    imports: [RouterLink],
    templateUrl: './breadcrumbs.component.html',
    styles: `
        :host {
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            gap: 8px;
            font-size: 14px;
            color: #1f2328;
        }

        .sep {
            color: #9aa0a6;
            font-size: 12px;
        }
    `,
    host: {
        'role': 'navigation',
        'aria-label': 'Kruimelpad'
    }
})
export class BreadcrumbsComponent {
    readonly crumbs = input<Crumbs>([]);
}
